import axios from "axios";

import { TTP_API_URL } from "../config";
import {
  getRequestCancellationToken,
  getRequestConfig,
  generateCancellationTokenSource,
  throwCatchedError,
} from "../utils";

let getServicesCTS;

export const saveService = async (token, data) => {
  const requestUrl = `${TTP_API_URL}/blog/service`;
  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("titleFr", data.titleFr);
  formData.append("titleNl", data.titleNl);
  formData.append("titleEn", data.titleEn);
  formData.append("descriptionFr", data.descriptionFr);
  formData.append("descriptionEn", data.descriptionEn);
  formData.append("descriptionNl", data.descriptionNl);
  formData.append("organization", data.organization);
  formData.append("image", data.image);
  formData.append("pageInfo", data.pageInfo);

  if (data.id) {
    formData.append("id", data.id);
  }
  let requestConfig = getRequestConfig();
  return await axios.post(requestUrl, formData, requestConfig);
};

export const getServices = (token, organization) => {
  const requestUrl = `${TTP_API_URL}/blog/service`;
  const serviceFilter = [];
  if (organization) {
    serviceFilter.push({
      property: "organization",
      value: organization,
      operator: "eq",
    });
  }
  const sort = [
    {
      property: "updatedAt",
      dir: "desc",
    },
  ];
  const params = {
    access_token: token,
    filter: JSON.stringify(serviceFilter),
    sort: JSON.stringify(sort),
  };
  let requestConfig = getRequestConfig(params);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const deleteService = (token, id) => {
  const requestUrl = `${TTP_API_URL}/blog/service/${id}`;
  var formData = new FormData();

  formData.append("access_token", token);
  formData.append("_method", "delete");

  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};
